import React, { useEffect } from "react";
import { Form, Input, InputNumber, Button, Checkbox } from "antd";
import { LoadingIcon, TopDropdown } from "../../../components";

const CreateModalContent = ({ data, setOpen, createCallback, cropData }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    console.log({ data });
  }, []);

  const onFinish = (values) => {
    console.log({ values });
    createCallback(values);
    setOpen(false);
    form.resetFields();
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <div className="flex justify-center ">
      <Form
        id="createOrgForm"
        form={form}
        className="max-w-[80%]"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Form.Item
          className="mr-2"
          name="name"
          label="Name"
          rules={[
            {
              required: true,
              message: "Required",
            },
          ]}
        >
          <Input placeholder="Name" />
        </Form.Item>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="maximum_site_allowed"
            label="Max Site"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            className="mr-2"
            name="maximum_user_allowed"
            label="Max User"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
        </div>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="maximum_crop_allowed"
            label="Max Crop"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            className="mr-2"
            name="maximum_plot_allowed"
            label="Max Plot"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber />
          </Form.Item>
        </div>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="is_active"
            valuePropName="checked"
            initialValue={false}
            label="Active"
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            className="mr-2"
            name="is_breeder"
            initialValue={false}
            valuePropName="checked"
            label="Breeder"
          >
            <Checkbox />
          </Form.Item>
        </div>
        <div className="flex items-center justify-around">
          <Form.Item
            className="mr-2"
            name="is_grower"
            initialValue={false}
            valuePropName="checked"
            label="Grower"
          >
            <Checkbox />
          </Form.Item>
          <Form.Item
            className="mr-2"
            name="is_pollination"
            initialValue={false}
            valuePropName="checked"
            label="Pollination"
          >
            <Checkbox />
          </Form.Item>
        </div>
        <Form.Item
          name="crops"
          label="Select Crops"
          rules={[
            { required: true, message: "Please select at least one crop" },
          ]}
        >
          <TopDropdown
            value={form.getFieldValue("crops")}
            placeholder="Select Crops"
            changeCallback={(val) => form.setFieldValue("crops", val)}
            notFound={cropData ? <LoadingIcon /> : null}
            data={cropData?.map((crop) => ({
              value: crop.id,
              label: crop.display_name,
            }))}
            mode="multiple"
          />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default CreateModalContent;
